import { DateFormats } from "us.common/constants";
import { RateActions } from "us.collection.admin/constants";
import * as Yup from "yup";
import dayjs from "dayjs";

export default (
  rates: Array<any>,
  drawerType: RateActions,
  initStandardRateDetails: any
) => {
  return Yup.object().shape({
    rate: Yup.number()
      .nullable()
      .required("US.COLLECTION.ADMIN:VALIDATIONS.RATE_IS_REQUIRED")
      .moreThan(0, "US.COLLECTION.ADMIN:VALIDATIONS.INVALID_RATE"),
    effectiveDate: Yup.string()
      .required("US.COLLECTION.ADMIN:VALIDATIONS.EFFECTIVE_DATE_IS_REQUIRED")
      .test(
        "unique-effective-date",
        "US.COLLECTION.ADMIN:VALIDATIONS.EFFECTIVE_DATE_ALREADY_EXISTS",
        function (value) {
          const existingDates = rates.map((rate) =>
            dayjs(rate?.effectiveDate).format(DateFormats.FORMAT_1)
          );

          if (drawerType != RateActions.NEW) {
            return !existingDates
              ?.filter(
                (effectiveDate) =>
                  effectiveDate !=
                  dayjs(initStandardRateDetails.effectiveDate).format(
                    DateFormats.FORMAT_1
                  )
              )
              .includes(dayjs(value).format(DateFormats.FORMAT_1));
          } else {
            return !existingDates.includes(
              dayjs(value).format(DateFormats.FORMAT_1)
            );
          }
        }
      ),
    comment: Yup.string()
      .nullable()
      .test(
        "comment-validation",
        "US.COLLECTION.ADMIN:VALIDATIONS.COMMENT_IS_REQUIRED",
        function (value) {
          if (drawerType != RateActions.NEW) {
            return !!value;
          }
          return true;
        }
      ),
  });
};
